(() => {
  if (window.keysapoCategorySearchReady) return;
  window.keysapoCategorySearchReady = true;
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-keysapo-category-search]');
    if (!form) return;
    const query = form.querySelector('[name="q"]');
    const category = form.querySelector('[data-major-category]');
    const term = query.value.trim();
    const selected = category.selectedOptions[0];
    if (!term) {
      event.preventDefault();
      window.location.assign(selected.dataset.collectionUrl || form.dataset.allProductsUrl);
      return;
    }
    if (category.value) {
      // Explicit tag search works without a Search & Discovery filter definition.
      event.preventDefault();
      const url = new URL(form.action);
      const parameters = new URLSearchParams(new FormData(form));
      parameters.set('q', `(${term}) AND tag:"${category.value}"`);
      url.search = parameters.toString();
      window.location.assign(url);
    }
  });
})();
